(function (app) {

    app.provider("queueApi",
        [
            function () {
                this.$get = [
                    "complianceHubApiGateway", function (complianceHubApiGateway) {
                        var service = {};

                        service.getQueue = function(queueId) {
                            return complianceHubApiGateway.get("/Queue/" + queueId);
                        }
                        service.getQueues = function () {
                            return complianceHubApiGateway.getArray("/Queue/");
                        }

                        service.getTransactionsForQueue = function (queueId) {
                            return complianceHubApiGateway.getArray("/Queue/" + queueId + "/Transactions");
                        }

                        service.getUserReviewQueue = function () {
                            return complianceHubApiGateway.get("/Queue/UserReviewQueue");
                        }

                        service.updateQueueEmails = function(queueId, emails) {
                            return complianceHubApiGateway.put("/Queue/" + queueId + "/Emails", emails);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line